import { render } from "./ListeCouleurPage.vue?vue&type=template&id=4f58f7fd&ts=true"
import script from "./ListeCouleurPage.vue?vue&type=script&lang=ts"
export * from "./ListeCouleurPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__